import { Box, Button, Card, CardBody, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, Flex, Grid, GridItem, Heading, Image, Popover, PopoverBody, PopoverContent, PopoverTrigger, Text, useDisclosure } from '@chakra-ui/react'
import MyDiv from './proofOfInvestment.style'
import { CalendarIcon } from '@chakra-ui/icons';
import Calendar from 'react-calendar';
import { useState } from 'react';
import TaxFiledIcon from "../../../assets/images/TaxFiledIcon.svg";
import PendingTaxIcon from "../../../assets/images/PendingTaxIcon.svg";
import OverDueIcon from "../../../assets/images/OverDueIcon.svg";
import TotalTaxIcon from "../../../assets/images/TotalTaxIcon.svg";
import { CustomButton } from '../../../components';
import {ProofDeclarationCard, ProofDeclarationList } from '../components';

const ProofOfInvestment = () => {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [toggle, setToggle] = useState(false);
    const formatMonthYear = (date: Date) => date.toLocaleString('default', { month: 'long', year: 'numeric' });
    const taxCards = [
        {
            title: "Total Employees Declared",
            value: "200",
            icon: TaxFiledIcon,
        },
        {
            title: "Proofs Submitted",
            value: "50",
            icon: PendingTaxIcon,

        },
        {
            title: "Pending Submissions",
            value: "40",
            icon: OverDueIcon,

        },
        {
            title: "Total Tax Deduction",
            value: "₹ 3500",
            icon: TotalTaxIcon,

        },
        {
            title: "More actions",
            value: "",
            icon: '',
            hasButton: true
        }
    ];

    const handleOpen = () => setToggle((prev) => !prev);
    const handleClose =()=>setToggle(false);

    return (
        <MyDiv>
            <Box>
                <Flex className="page_heading flex_header">
                    <Text className="font-poppins text_3xl text_semibold">Proof of Investment</Text>
                    <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose} placement="bottom-end">
                        <PopoverTrigger>
                            <Button leftIcon={<CalendarIcon />} padding={3} variant="outline" >
                                <Text className="font-poppins text_sm text_regular">{formatMonthYear(selectedDate)}</Text>
                            </Button>
                        </PopoverTrigger>
                        <PopoverContent w="auto">
                            <PopoverBody p={2} display="flex" justifyContent="center">
                                <Calendar
                                    value={selectedDate}
                                    onChange={(value) => {
                                        if (value instanceof Date) {
                                            setSelectedDate(value);
                                            onClose();
                                        }
                                    }}
                                    view="year"
                                    maxDetail="year"
                                    maxDate={new Date()}
                                />
                            </PopoverBody>
                        </PopoverContent>
                    </Popover>
                </Flex>

                <Grid templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(3, 1fr)", lg: "repeat(5, 1fr)" }} gap={4}>
                    {taxCards.map((card, index) => (
                        <GridItem key={index} colSpan={1} mt={4}>
                            <Card className="card" height="100%">
                                <CardBody p={4} height="100%">
                                    <Flex direction="column" justifyContent="space-between" height="100%">
                                        <Box>
                                            <Flex alignItems="center" mb={2}>
                                                {card.icon && <Image src={card.icon} alt={card.title} mr={2} />}
                                                <Text className="font-poppins text_lg text_medium">{card.title}</Text>
                                            </Flex>
                                        </Box>

                                        <Flex direction="column" align="flex-start" mt="auto">
                                            {card.value && (
                                                <Text className="font-poppins text_5xl text_semibold">{card.value}</Text>
                                            )}

                                        </Flex>
                                        {card.hasButton && (
                                            <CustomButton title="View" className="btn" onClick={handleOpen} />
                                        )}
                                    </Flex>
                                </CardBody>
                            </Card>
                        </GridItem>
                    ))}
                </Grid>

                <Grid className='grid_container'>
                    <GridItem colSpan={12} mt={6}>
                        <ProofDeclarationList />
                    </GridItem>
                </Grid>
            </Box>
            <Drawer isOpen={toggle} placement="right" onClose={handleClose} size="sm">
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader borderBottomWidth="1px" className='font-poppins text_xl text_semibold'>Proof of Investment</DrawerHeader>
                    <DrawerBody>
                        <ProofDeclarationCard />
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </MyDiv>
    )
}

export default ProofOfInvestment;
